import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyA8LdTrFL4CN_zZMshOM5a7miNNbd5deCo",
    authDomain: "hockeyinfo-2f614.firebaseapp.com",
    databaseURL: "https://hockeyinfo-2f614.firebaseio.com",
    projectId: "hockeyinfo-2f614",
    storageBucket: "hockeyinfo-2f614.appspot.com",
    messagingSenderId: "498891042254"
};
const fire = firebase.initializeApp(config);

export default fire;


// WEBPACK FOOTER //
// ./src/fire.js